<template>
	<div id="index">
		<!-- 头部 -->
		<v-header :selectedItemVal="1" ref="header" v-if="!userInfo">首页</v-header>
		<!-- 主体 -->
		<div class="main">
			<div class="indexBanner" :class="userInfo ? 'indexBanner-login' : 'indexBanner-logout'">
				<!-- 头部 -->
				<v-header  :selectedItemVal="1" ref="header" v-if="userInfo">首页</v-header>
				<div class="content">
					<div class="bannerLeft">
						<div class="indexLivePlay">
							<v-livePlay ref="livePlay" :playerOptions="playerOptions"></v-livePlay>
							
							<!-- 首页进入直播间 -->
							<div class="indexLiveTip" @mouseenter="indexLiveTipShow = true" @mouseleave="indexLiveTipShow = false">
								<div class="toDetail" @click="goLiveDetailPage()">
									<img src="../../assets/img/live/进入直播间.png" v-if="indexLiveTipShow == false"  alt="">
									<img src="../../assets/img/live/进入直播间备份.png" v-if="indexLiveTipShow == true" alt="">
								</div>
							</div>
						</div>
					</div>
					<div class="bannerRight">
						<div class="living-item" :class="{livingSelected:nowPlayLiveId == item.lvrId}" v-for="(item,index) in livingData" :key="index" @click="lookLiveChange(item)">
							<div class="item">
								<el-image :src="item.lvrImgSmallUrl"></el-image>
							</div>
							<div></div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="middle-main">
				<!-- 直播预告 -->
				<div id="live-preview">
					<div class="title">
						<h2>直播预告</h2>
					</div>
					<div class="content">
						<v-livePreview :liveVideoList="liveVideoList"></v-livePreview>
					</div>
				</div>
				
				<!-- 牛策略 -->
				<!-- <div id="bull-strategy">
					<div class="title">
						<h2>牛策略</h2>
					</div>
					<div class="content">
						<v-strategyList :strategyData="strategyList"></v-strategyList>
					</div>
				</div> -->
				<!-- 牛人课 -->
				<!-- <div id="bull-class">
					<div class="title">
						<h2>牛人课</h2>
					</div>
					<div class="content">
						<v-classList :bullClassData="bullClassList"></v-classList>
					</div>
				</div> -->
			</div>
		</div>
		<!-- 尾部 -->
		<v-footer></v-footer>
	</div>
</template>

<script>
import vHeader from '../common/header'
import vFooter from '../common/footer'
import vIndexSwiper from '../common/index_swiper'
import vLivePreview from '../common/live_preview'
import vStrategyList from '../common/strategy_list'
import vClassList from '../common/class_list'
import vLivePlay from '../common/livePlay'

export default {
	name:'index',
	components: {
      'v-header': vHeader,
	  'v-footer':vFooter,
	  'v-indexSwiper':vIndexSwiper,
	  'v-livePreview':vLivePreview,
	  'v-strategyList':vStrategyList,
	  'v-classList':vClassList,
	  'v-livePlay':vLivePlay,
    },
	data(){
		return {
			src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
			//登录用户信息
			userInfo:JSON.parse(localStorage.getItem('user')),
			activeLiveData:{},
			nowPlayLiveId:0,
			livingData:[], //正在直播数据
			liveVideoList:[], //直播预告数据
			strategyList:[], //牛策略数据
			bullClassList:[], //牛人课数据
			liveDetail:{},
			indexLiveTipShow:false,
			passwordLivePass:false,	//直播密码房通行
			liveListPage:1,
			canRequestLiveList:true,
			playerOptions:{
				height:'590px',
			},
		}
	},
	watch:{
		'$route':function(to,from){
			// console.log('侦听路由变更',to,from)
			//+-----------未登录情况下，弹出登录框---------------
			if(to.query.auth == 0){
				this.$refs.header.login();
			}
		}
	},
	mounted() {
		//+----------------------监听直播列表滚动---------------
		document.querySelector('.bannerRight').addEventListener('scroll',this.liveListScroll);
		
		setTimeout(() => {
			this.getLiveList();
			this.getfirstContentList();
		},500);
	},
	methods:{
		getLiveList(){
			//+----------------构建请求参数-------------------
			let data = {
				page:this.liveListPage,
			};
			//+-----------------获取直播推荐位列表-----------
			this.apiServer.live.getList(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200 && res.data.data.appSingleLiveResponseVOList){
					if(res.data.data.appSingleLiveResponseVOList.length <= 0){
						this.liveListPage = 1;
						this.canRequestLiveList = false;
						return false;
					}
					
					if(this.liveListPage == 1){
						//直播列表数据
						this.livingData = res.data.data.appSingleLiveResponseVOList;
						this.getRecommentList();
					}else{
						res.data.data.appSingleLiveResponseVOList.some(item => {
							this.livingData.push(item);
						});
					}
					
					this.liveListPage++;
				}
			})
			.catch(res => {
				console.log('获取直播推荐异常');
			});
		},
		//首页查询直播预告, 热门课程, 斗牛策略列表
		getfirstContentList(){
			//+----------------构建请求参数------------------
			let data = {
				applicationType:this.store.state.applicationType,
			};
			
			//+-----获取首页直播预告、牛策略、牛人课列表------
			this.apiServer.live.getfirstContentList()
			.then(res => {
				if(res.data.code == 200){
					this.liveVideoList = res.data.data.liveVideoList;
					this.strategyList = res.data.data.niuContentList;
					this.bullClassList = res.data.data.niuRenCourseList;
				}
			})
			.catch(res => {
				console.log('首页数据获取异常');
			});
		},
		//获取牛人课
		getBullClassList(){
			//+-----------------获取牛人课列表---------------------
			this.apiServer.bullClass.getListByWeb()
			.then(res => {
				if(res.data.code == 200){
					this.bullClassList = res.data.data.videos;
				}
			})
			.catch(res => {
				this.$message.error('获取牛人课列表异常');
			});
			
		},
		//获取牛策略
		getBullStrategyList(){
			//+-----------------获取牛策略列表---------------------
			this.apiServer.bullStrategy.getList()
			.then(res => {
				if(res.data.code == 200){
					
				}
			})
			.catch(res => {
				this.$message.error('获取牛策略列表异常');
			});
		},
		//观看直播切换
		lookLiveChange(item){
			//+----------更新当前选中直播间数据-------------
			this.activeLiveData = item;
			//+------------更新当前观看直播id--------------
			this.nowPlayLiveId = item.lvrId;
			
			//+----------------验证是否密码房直播----------
			if(!this.isPasswordLive()){
				this.$refs.livePlay.nowRoomId = item.lvrId;
			}
		},
		//进入直播间
		goLiveDetailPage(){
			//+-----------------------当前窗口跳转----------------------
			this.$router.push({name:'liveDetail',query:{room_id:this.nowPlayLiveId}});
		},
		//获取推荐位
		getRecommentList(){
			if(!this.canRequestLiveList) return false;
			var _this = this;
			//+-----------------------构建参数----------------------
			let data = {};
			//+---------------------请求推荐数据---------------------
			this.apiServer.live.getRecommentList(this.qs.stringify(data))
			.then(res => {
				if(res.data.code == 200 && res.data.data.businessCode == 10){
					res.data.data.appSingleLiveResponseVOList.forEach(function(item){
						_this.livingData.unshift(item);
					});
					
					//默认接收观看第一个直播
					this.activeLiveData = _this.livingData[0];
					this.nowPlayLiveId = _this.livingData[0].lvrId;
					
					if(!_this.isPasswordLive()){
						//+-----------初始化当前观看直播id---------------
						_this.$refs.livePlay.nowRoomId = _this.nowPlayLiveId;
					}
				}
				
				// console.log('合并',_this.livingData.concat(res.data.data.appSingleLiveResponseVOList))
			})
			.catch(error => {
				console.log(error)
			});
		},
		//是否密码房直播
		isPasswordLive(){
			if(this.activeLiveData && this.activeLiveData.canEnter == 0 && this.activeLiveData.hasLock == 1){
				//直播显示密码房提示
				this.$refs.livePlay.isPasswordLive = true;
				return true;
			}else{
				this.$refs.livePlay.isPasswordLive = false;
				return false;
			}
		},
		//密码直播间
		passwordLive(){
			//+-----------------------验证是否登录------------------
			if(!localStorage.getItem('user')){
				this.$alert('请您登录后操作', '您未登录', {
					confirmButtonText: '确定',
					callback: action => {
						this.$refs.header.login();
					}
				});
				return false;
			}
			//+-------------------判断是否密码房直播-------------------------
			this.$prompt('请输入直播间密码', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /[\d]/,
				inputErrorMessage: '密码格式不正确'
			}).then(({ value }) => {
				//+------------------构建直播间密码验证参数--------------------
				let data = {
					lvrId:this.nowPlayLiveId,
					pwd:value
				};
				//+-----------------------验证直播间密码-----------------------
				this.apiServer.live.checkLivePwd(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200 && res.data.data.businessCode == 10){
						//密码输入成功,隐藏密码房提示并加载视频播放
						this.$refs.livePlay.isPasswordLive = false;
						this.$refs.livePlay.nowRoomId = this.nowPlayLiveId;
					}else{
						this.$message({
							type:'info',
							message:res.data.data.businessMessage
						});
					}
				})
				.catch(error => {
					this.$message.error(error);
				});
			})
			.catch(error => {
				this.$message({
					type:'info',
					message:'取消输入'
				});
			});
		},
		//监听直播列表滑动
		liveListScroll(){
			const scrollObj = document.querySelector(".bannerRight");
			const scrollTop = scrollObj.scrollTop;
			const scrollHeight = scrollObj.scrollHeight;
			const offsetHeight = scrollObj.offsetHeight;
			if(scrollTop == 0){
				// console.log('到顶部');
				
			}
			
			if ((offsetHeight + scrollTop) - scrollHeight >= -1) {
				// console.log('到底部');
				if(this.canRequestLiveList){
					//请求直播列表
					this.getLiveList();
				}
			}
		},
	}
}
</script>

<style>
	.indexBanner{
		margin: 0 auto;
	}
	
	.indexBanner-login{
		background: url(../../assets/img/index/index_bg.png) no-repeat center;
		background-size: 100% 106%;
	}
	.indexBanner-logout{
		background: url(../../assets/img/index/banner_bg.png) no-repeat center;
		background-size: cover;
	}
	
	.indexBanner #nav ul>li:nth-child(1){
		color: #FFFFFF !important;
	}
	
	.indexBanner #header a{
		color:#FFFFFFFF;
	}
	
	.indexBanner #nav ul>li>a:hover{
		background-color: pink;
		border-radius: 1.75rem;
	}
	.indexBanner .active {
		background-color: #FFFFFF !important;
		color: #C60B09 !important;
	}
	
	.indexBanner .el-dropdown{
		color: #FFFFFFFF;
	}
	
	.indexBanner .denglu a{
		/* font-size: 24px; */
		color: #FFFFFFFF;
	}
	
	.indexBanner .content{
		width: 1265px;
		height: 610px;
		margin: 0px auto;
		display: flex;
		background: url(../../assets/img/index/index_bg2.png) no-repeat;
		background-size: 100% 100%;
	}

	.indexBanner .content .bannerLeft{
		width: 1050px;
		height: 590px;
		margin: 9px 0 0 9px;
	}
	
	.indexBanner .content .bannerLeft .indexLivePlay{
		height: 100%;
		background: url(../../assets/img/live/no_play.png) no-repeat;
		background-size: cover;
		position: relative;
	}
	.indexLivePlay .not_living img{
		width: 100%;
		height: 100%;
	}
	
	.indexBanner .content .bannerRight{
		width: 190px;
		height: 590px;
		margin: 9px 9px 0px 10px;
		overflow-y: auto;
	}
	
	/* 右侧滚动条 */	
	.bannerRight::-webkit-scrollbar {
		/*滚动条整体样式*/
		width : 5px;  /*高宽分别对应横竖滚动条的尺寸*/
		height: 1px;
	}
	.bannerRight::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius   : 10px;
		background-color: red;
		background-image: -webkit-linear-gradient(
		  45deg,
		  rgba(255, 255, 255, 0.2) 25%,
		  transparent 25%,
		  transparent 50%,
		  rgba(255, 255, 255, 0.2) 50%,
		  rgba(255, 255, 255, 0.2) 75%,
		  transparent 75%,
		  transparent
		);
	}
	.bannerRight::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
		background   : #ededed;
		border-radius: 10px;
	}
	
	.bannerRight .living-item{
		height: 150px;
		margin-bottom: 10px;
		cursor: pointer;
	}
	
	.bannerRight .livingSelected{
		border-width: 2px 0px 2px 2px;
		border-color: orange;
		border-style: solid;
	}
	
	.living-item img{
		width: 180px;
		height: 150px;
	}
	
	.bannerRight .el-col .el-image{
		
		padding: 0.625rem;
		/* max-height: 9.375rem; */
		margin: 0 auto;
	}
	
	.el-main .title h2{
		text-align: left;
		margin-left: 0.625rem;
	}
	
	.middle-main{
		width: 1250px;
		margin: 0 auto;
	}
	
	.payLiveDesc{
		top: 100px;
	}
	
	/* 首页隐藏直播购买按钮 */
	.bannerLeft .payLiveDesc>.not_living-pay{
		display: none;
	}
	
	.indexLiveTip{
		width: 100%;
		height: 100px;
		text-align: center;
		position: absolute;
		color: #FFFFFFFF;
		z-index: 2;
		top: 50%;
	}
	
	.indexLiveTip .toDetail{
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		cursor: pointer;
	}
	
	.swiper-container{
		width: 100%;
		margin-left: 0;
	}
	
	.swiper-wrapper{
		justify-content: space-between;
	}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue